import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import Button from '@/components-latest/primitives/Button'
import ChipSelect from '@/components-latest/primitives/Controls/ChipSelect'
import MenuItemCard from '@/components-latest/ui/OfferPage/MenuItemCard/MenuItemCard'
import { useToaster } from '@/components-latest/ui/Toaster/useToaster/useToaster'
import { FIREBASE_APP_ID, GOOGLE_API_KEY } from '@/constants/env'
import {
  WSNewOrderMessage,
  WSRejectedOrderMessage,
  WSStoreStatusMessage
} from '@/ducks/events/events.types'
import { eventActions } from '@/ducks/events/slice/events.slice'

const generateOptions = (count: number) => {
  return Array.from({ length: count }, (_, i) => ({
    value: `option-${i + 1}`,
    label: `Option ${i + 1}`
  }))
}
const options = generateOptions(500)

const TestPage = () => {
  const { addToast } = useToaster()

  const dispatch = useDispatch()

  const [value, setValue] = useState<{ value: string; label: string }[]>([])
  console.log(value)

  return (
    <div style={{ margin: 24, background: '#f7f3f8' }}>
      <h1>Test Page</h1>
      <h2>System Toasts</h2>
      {/*todo remove after checking if it is set on staging*/}
      fbase app id devops test
      <h3>{String(FIREBASE_APP_ID)}</h3>
      google api key devops test
      <h3>{String(GOOGLE_API_KEY)}</h3>
      <Button
        style={{ margin: 24 }}
        variant="secondary"
        onClick={() =>
          addToast({
            type: 'system',
            intent: 'success',
            message: 'new success toast'
          })
        }>
        render system toast Success
      </Button>
      <Button
        style={{ margin: 24 }}
        variant="secondary"
        onClick={() =>
          addToast({
            type: 'system',
            intent: 'error',
            message: 'new error toast'
          })
        }>
        render system toast Error
      </Button>
      <Button
        style={{ margin: 24 }}
        variant="secondary"
        onClick={() =>
          addToast({
            type: 'system',
            intent: 'warning',
            message: 'new warning toast'
          })
        }>
        render system toast Warning
      </Button>
      <Button
        style={{ margin: 24 }}
        variant="secondary"
        onClick={() =>
          addToast({
            type: 'system',
            intent: 'info',
            message: 'new info toast'
          })
        }>
        render system toast Info
      </Button>
      <h2>New Order Toasts</h2>
      <Button
        style={{ margin: 24 }}
        variant="secondary"
        onClick={() =>
          addToast({
            type: 'newOrder',
            orderDetails: {
              earnings: 999.99,
              user: {
                username: 'Elize',
                last_name: 'Bronx',
                avatar: ''
              },
              isReady: false,
              order_id: 'YAF-1718104032218',
              foods: [
                {
                  name: {
                    en: 'Zinger Burger'
                  },
                  id: '661d1bcaf1d5e5000dc0a322',
                  price: 1,
                  slug: 'Zinger Burger',
                  quantity: 6,
                  instruction: '',
                  addons: [],
                  main_category: {
                    en: 'burgers',
                    ar: 'burgers',
                    fr: 'burgers'
                  },
                  total: 6,
                  barcode: '',
                  base_pack: [],
                  type_pack: []
                },
                {
                  name: {
                    en: 'Newest bulk upload with error',
                    fr: 'Nouvelle pizza',
                    ar: 'بيتزا جديدة'
                  },
                  id: '661d1dbbeec121000ce02578',
                  price: 1000,
                  slug: 'Newest bulk upload with error',
                  quantity: 1,
                  instruction: '',
                  addons: [],
                  main_category: {
                    en: 'Pizzas',
                    ar: 'Pizzas',
                    fr: 'Pizzas'
                  },
                  total: 1000,
                  barcode: '',
                  base_pack: [],
                  type_pack: []
                }
              ],
              status: {
                key: 'CANCELED',
                title: {
                  ar: 'Canceled',
                  fr: 'Canceled',
                  en: 'Canceled'
                }
              },
              time_out: 3000000,
              order_time: 1718103972648,
              estimated_preparation_time: 1200000,
              time_left: 10000 + Math.random() * 10000,
              returned: false,
              assigned: false,
              isReturnedToStock: false,
              driver_name: '',
              remainingETA: 0,
              support: {
                code: '+213',
                number: '555121212'
              },
              store_name: {
                en: 'New test restaurant',
                fr: 'New test restaurant',
                ar: 'New test restaurant'
              }
            }
          })
        }>
        render new order toast
      </Button>
      <Button
        style={{ margin: 24 }}
        variant="branded"
        onClick={() =>
          dispatch(
            eventActions.new_order({
              _id: '12',
              order_id: 'YAF-1716134957240',
              restaurant: { _id: '6603197627948cc0e80b83f1' }
            } as WSNewOrderMessage & void & WSRejectedOrderMessage & WSStoreStatusMessage)
          )
        }>
        Send notification
      </Button>
      <h2>Chip Select</h2>
      <div>
        <ChipSelect
          name="chip-select"
          value={value}
          onChange={options => setValue(options)}
          options={options}
          placeholder="Select options..."
          isSearchable={true}
          isClearable={true}
          closeMenuOnSelect={false}
        />
      </div>
      <h2>Menu Item Card </h2>
      <div style={{ display: 'flex', gap: 16 }}>
        <MenuItemCard
          _id="test-id"
          name={{
            en: 'Tacos philly-en',
            fr: 'Tacos philly-fr',
            ar: 'Tacos philly-ar'
          }}
          price={3}
          avatar="https://placehold.co/600x400.png"
        />
        <MenuItemCard
          _id="test-id"
          name={{
            en: 'overflowy name overflowy name  overflowy name overflowy name en',
            fr: 'overflowy name overflowy name  overflowy name overflowy name fr',
            ar: 'overflowy name overflowy name  overflowy name overflowy name ar'
          }}
          price={12.01}
          avatar="https://placehold.co/600x400.png"
        />
        <MenuItemCard
          _id="test-id"
          name={{
            en: 'Overpriced pizza-en',
            fr: 'Overpriced pizza-fr',
            ar: 'Overpriced pizza-ar'
          }}
          price={12222222213343.043}
          avatar="https://placehold.co/600x400.png"
        />
      </div>
    </div>
  )
}

export default TestPage
